import {Component} from "@angular/core";

@Component({
  selector: "core-binding",
  template: `
<usecase-container title="Binding" src="core/binding">
  <usecase-content>
    <input type="text" (input)="onInput($event.target.value)" [value]="text">
    <p>{{ text }}</p>
  </usecase-content>
</usecase-container>
  `
})
export class BindingComponent {
  text: string = "sample";

  onInput(value: string) {
    this.text = value;
  }
}



/** WEBPACK FOOTER **
 ** ./script/core/binding/component.ts
 **/